import { api, apiUpload } from './client';
import type { Attachment } from '../types';

export function listAttachments(
  batchId: string,
): Promise<{ items: Attachment[] }> {
  return api(`/api/batches/${batchId}/attachments`);
}

export function uploadAttachment(
  batchId: string,
  file: File,
): Promise<Attachment> {
  return apiUpload(
    `/api/batches/${batchId}/attachments`,
    file,
    file.name,
    file.type,
  );
}

export function deleteAttachment(id: string): Promise<{ ok: true }> {
  return api(`/api/attachments/${id}`, { method: 'DELETE' });
}
